module.exports = __webpack_public_path__ + "img/dial-med-low.c6c7f61d.svg";